export const LSK_SIDEBAR_VISIBILITY = 'tt_sidebar_visibility';
